import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { ProyectoInformeFinalDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class ProyectoInformeFinalService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getProyectoInformeFinalService(): Observable<BodyListResponse<ProyectoInformeFinalDTO>> {
    return this.http.get<BodyListResponse<ProyectoInformeFinalDTO>>(API_URL + '/api/v1/proyectoInformeFinal/todos');
  }

  guardarProyectoInformeFinalService(proyectoInformeFinalDTO: ProyectoInformeFinalDTO): Observable<BodyResponse<ProyectoInformeFinalDTO>> {
    return this.http.post<BodyResponse<ProyectoInformeFinalDTO>>(API_URL + '/api/v1/proyectoInformeFinal', proyectoInformeFinalDTO);
  }

  getProyectoInformeFinalPorCodigoService(codigo: string): Observable<BodyResponse<ProyectoInformeFinalDTO>> {
    return this.http.get<BodyResponse<ProyectoInformeFinalDTO>>(API_URL + '/api/v1/proyectoInformeFinal/' + codigo);
  }

  getProyectoInformeFinalPorCodigoPlanTrabajoService(codigo: string): Observable<BodyListResponse<ProyectoInformeFinalDTO>> {
    return this.http.get<BodyListResponse<ProyectoInformeFinalDTO>>(API_URL + '/api/v1/proyectoInformeFinal/plan/' + codigo);
  }

  getProyectoInformeFinalPorPlanCategoríaService(codigoProyecto: string, codigoCategoria: string): Observable<BodyListResponse<ProyectoInformeFinalDTO>> {
    return this.http.get<BodyListResponse<ProyectoInformeFinalDTO>>(API_URL + '/api/v1/proyectoInformeFinal/plan/' + codigoProyecto + '/' + codigoCategoria);
  }


  getProyectoInformeFinalPorParticipanteService(codigoParticipante: string): Observable<BodyListResponse<ProyectoInformeFinalDTO>> {
    return this.http.get<BodyListResponse<ProyectoInformeFinalDTO>>(API_URL + '/api/v1/proyectoInformeFinal/proyectoParticipante/' + codigoParticipante);
  }

}
